$(function(){

    'use strict';

    window.currentParams = {
        page: 1,
        perPage: 30,
        sortField: null,
        sortDirection: null
    };

    // first load
    loadLatestJobs(window.currentParams);

    // reload with perpage 
    $('.latest_jobs').on('change', '.perpage-select select', function(){
        window.currentParams.page = 1;
        window.currentParams.perPage = $(this).val();
        loadLatestJobs(window.currentParams);
    });

    // reload with page
    $('.latest_jobs').on('click', '.pagination-controls nav ul li', function(e){

        if($(e.target).parent().hasClass('disabled') || $(e.target).parent().hasClass('active')) { // no action if disabled/active btns
            return false;
        }

        window.currentParams.page = $(e.target).attr('data-page');
        loadLatestJobs(window.currentParams);
    });

    $('.latest_jobs .sort-control').on('click', function () {
        const field = $(this).data('field');
        let direction = 'asc';
        if (window.currentParams.sortField === field) {
            direction = window.currentParams.sortDirection === 'asc' ? 'desc' : 'asc';
        }
        window.currentParams.page = 1;
        window.currentParams.sortField = field;
        window.currentParams.sortDirection = direction;
        loadLatestJobs(window.currentParams);
    });

});

/**
 * load latest jobs
 *
 * @param {int} page
 * @param {int} perPage
 * @param sortField
 * @param sortDirection
 */
function loadLatestJobs({ page, perPage, sortField, sortDirection })
{
    let loader = `<h2 class="text-center loadingCogAnime">
                <span class="icon fa fa-cog fa-spin"></span>
                Loading data. Please wait...
            </h2>`;
    
    // loader anim
    $('.latest_jobs table tbody').html(loader).css({ 'height' : '80px'});
    // disable multiple requests
    $('.perpage-select select').attr('disabled', 'disabled');
    $('.pagination-controls nav ul li').addClass('disabled');
    $('.latest_jobs .sort-control').removeClass('active');
    $('.latest_jobs .sort-control i').removeClass('fa-sort-asc fa-sort-desc').addClass('fa-sort');
    if (sortField) {
        $(`.latest_jobs .sort-control[data-field="${sortField}"]`).addClass('active');
        $(`.latest_jobs .sort-control[data-field="${sortField}"] i`)
            .removeClass('fa-sort fa-sort-asc fa-sort-desc')
            .addClass(`fa-sort-${sortDirection}`);
    }

    $.ajax({
        url: '/get_latest_jobs',
        type: 'post',
        dataType: 'json',
        data: {
            actions: 'get_latest_jobs',
            perPage: perPage,
            page   : page,
            sort_field: sortField,
            sort_direction: sortDirection,
        },
        success: function (response) {

            fillLatestJobsTable(response.data.jobs);

            if (response.data.pagination.total_jobs >= 30) { // show pagination
                buildPagination(response.data.pagination);
            }
            
            // add total jobs count
            $('#latest-jobs-count').html(" (" + response.data.pagination.total_jobs + ") ");
        },
        error: function (error) {
            console.log(error);
        }
    });
}

/**
 * build pagination function
 * 
 * @param {object} data 
 */
function buildPagination(data)
{
    $('.latest_jobs .pagination-holder').remove();
    $('.latest_jobs').append(`<div class="pagination-holder">
        <div class="pagination-controls d-flex">
            <nav>
            </nav>
        </div>
        <div class="perpage-select">
            Show <select>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select> entries
        </div>                      
    </div>`);

    $('.perpage-select select').find('option[value="'+ data.perpage +'"]').attr('selected', true);
 
    let start, end;

    if (data.total_pages <= 5) {
        start = 1;
        end   = data.total_pages;
    } else {
        start = Math.max(1, (data.current_page - 2));
        end   = Math.min(data.total_pages, (data.current_page + 2));

        if (start === 1) {
            end = 5;
        } else if (end === data.total_pages) {
            start = (data.total_pages - 4);
        }
    }

    let pagination = `<ul class="pagination">

    <li class="page-item ${ data.prev_page ? '' : 'disabled'}"><a class="page-link" data-page="1"> First </a></li>
    <li class="page-item ${ data.prev_page ? '' : 'disabled'}"><a class="page-link" data-page="${ data.prev_page }"> « </a></li>`;

    for(let i = start; i <= end; i++) {
        pagination += `<li class="page-item ${ data.current_page == i ? 'active' : '' }"><a class="page-link" data-page="${ i }">${ i }</a></li>`;
    }
    
    pagination += `<li class="page-item ${ data.next_page ? '' : 'disabled'}"><a class="page-link" data-page="${ data.next_page }}"> » </a></li>
    <li class="page-item ${ data.next_page ? '' : 'disabled'}"><a class="page-link" data-page="${ data.total_pages }}"> Last </a></li>
    </ul>`;

    $('.pagination-holder nav').html(pagination);
}

/**
 * fill latest jobs table
 * 
 * @param {object} data 
 */
function fillLatestJobsTable(data)
{
    let rows = '';

    for(let i = 0; i < data.length; i++)
    {
        rows += `<tr onclick="window.location.href='/vacancies?id=${data[i].id}'">
                <td>${data[i].location}</td>
                <td>${data[i].role}</td>
                <td>${data[i].employment_type}</td>
                <td>${formatVacancySalary({
                    'salaryDisplayType' : data[i].salary_display_type,
                    'salaryPrefix' : data[i].salary_prefix,
                    'salaryFrom' : data[i].salaryFrom,
                    'salaryTo' : data[i].salaryTo,
                    'paymentType' : data[i].salaryInfo.payment_type,
                    'salary' : data[i].salary,
                    'showSalary' : data[i].show_salary,
                })}</td>
        </tr>`;
    }

    $('.latest_jobs table tbody').css({ 'height' : 'auto'}).html(rows);
}

/**
 * format vacancy salary function
 * 
 * @param {object} data 
 * @returns 
 */
function formatVacancySalary(data)
{
    if (data.salaryDisplayType === 'Competitive') {

        return 'Competitive';

    } else if (data.salaryDisplayType === 'Single value') {

        let val = '';

        if (data.salaryPrefix === 'Starts at...') {
            
            val +=  'Starts at <span>'+ data.salaryFrom + '</span>';

        } else if (data.salaryPrefix === 'Up to...') {

            val += 'Up to <span>'+ data.salaryTo + '</span>';

        } else{
            
            val += '<span>' + data.salaryFrom + '</span>';
        }

        return val + ' ' + data.paymentType 

    } else if (data.salaryDisplayType === 'Range') {

        return '<span>'+ data.salaryFrom + '</span> to <span>'+ data.salaryTo + '</span> '+ data.paymentType;

    } else if(data.showSalary === 'Yes' && data.salary.length > 0){

        return '&#163;'+ data.salary;

    } else{
        return 'Undisclosed';
    }
}

if (window.flashMessage) {
    flashy('', window.flashMessage.content, window.flashMessage.type[0], false);
}